// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Site_StatsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /site/v1/stats — the minimal rows the franchise
 * page aggregates (countries, cities, units). One {pais, cidade} per visible
 * unit; the site keeps its own aggregation (lib/franchise-stats.ts).
 */
import type { Site_StatsLocalidadeRow } from './Site_StatsLocalidadeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Site_StatsResponseDados {
localidades: Site_StatsLocalidadeRow[]
total: number
}

export type Site_StatsResponse = ApiResponse<Site_StatsResponseDados>;

registerResponseContract('Site_StatsResponse', {
  localidades: {
    type: 'array',
    required: true,
    items: {
      pais:   { type: 'string',  required: false },
      cidade: { type: 'string',  required: false },
    },
  },
  total:       { type: 'number',  required: true },
})
